import { isRouteErrorResponse, useRouteError } from "react-router-dom";

import { appAsset } from "../../app.asset";

 
export interface RouteErrorBoundaryProps {}

export function RouteErrorBoundary() {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    return (
      <div>
        <h1>Error {error.status}</h1>
        <p>{error.statusText}</p>
      </div>
    );
  }
  return (
    <div id="RouteErrorBoundary" className="route-error-boundary">
      <div className="flex items-center justify-center h-screen bg-white">
        <div className="text-center flex flex-col items-center">
          <h1 className="text-6xl font-bold text-green-800 mt-4">
            OOPS... SOMETHING WENT WRONG
          </h1>

          <img src={appAsset.page404} alt="404 Robot" />
          <p className="text-xl text-gray-600 mt-2">
            I am sorry you are seeing this.
          </p>
          <p className="text-xl text-gray-600">
            An error occured. Kindly contact us immediately.
          </p>

          <div className="flex w-full flex-col mt-6">
            <span className="text-green-800 font-bold">info@bukolabs.io</span>
            <span className="text-green-800 font-bold">0917 122 5214</span>
          </div>

          <img
            src={appAsset.bukoLogo}
            className="w-[250px] cursor-pointer mt-10"
            alt="buko-labs"
          />
        </div>
      </div>
    </div>
  );
}

export default RouteErrorBoundary;
